import { Footer } from '@/design-system/components/footer/Footer';
import { Container, SxProp, View, Image } from 'dripsy';
import React from 'react';

interface PageContainerProps {
  sx?: SxProp;
  noBackgroundImage?: boolean;
}

export const PageContainer: React.FC<PageContainerProps> = ({ sx, noBackgroundImage, children }) => {
  return (
    <Container sx={{ ...styles.container, ...sx }}>
      <Image
        sx={{ position: 'fixed', top: 0, left: 0, width: '100%', height: 288, backgroundColor: '#625f5ce0' }}
        source={require('assets/images/headerBackground1.png')}
      />
      <View sx={{ flexGrow: 1 }}>{children}</View>
      <Footer />
    </Container>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    flex: 1,
    width: '100%',
    // maxWidth: '$maxDesktopScreenWidth',
    // marginX: 'auto',
    backgroundColor: 'transparent'
  }
};
